import React, {ChangeEvent, FC } from "react";
import _ from "lodash";
import { HeaderModel } from "../../../../models/CommonModel";
import { formatPrice } from "../../../../selectors";
import { ImportRequestDetailModel, ImportRequestModel } from "../../../../models/ImportRequestModel";
import { removeTrailingZeros } from "../../../../modules/common/helper";

type TProps = {
  importRequest?: ImportRequestModel,
  headers: HeaderModel[],
  hideCols: string[],
  handleChangeQty: (e: ChangeEvent<HTMLInputElement>, item: ImportRequestDetailModel) => void,
  handleChangeNote: (e: ChangeEvent<HTMLInputElement>, item: ImportRequestDetailModel) => void,
  toggleCheck: (e: ChangeEvent<HTMLInputElement>, item: ImportRequestDetailModel) => void,
  openColConfig: () => void,
  handleCheckAll?: (e: any) => void,
  editable: boolean,
  selected:number[]
  isIncorrect: boolean
}

const ProductTable: FC<TProps> = ({
    importRequest,
    headers,
    hideCols,
    openColConfig,
    handleChangeQty,
    handleChangeNote,
    toggleCheck,
    editable,
    selected,
    isIncorrect
  }) => {
  let details = importRequest?.details ?? []
  let isConfirmed = importRequest?.status === 'done';
  return <>
    <div className='table-responsive mt-5'>
      <table className={`table table-bordered border gy-7 gs-7`}>
        <thead>
        <tr className="fw-bold fs-6 text-gray-800 border-bottom-2 border-gray-200">
          {!isConfirmed && (
            <th>
            </th>
          )}
          {headers.map((th, index) => {
            if (!hideCols.includes(th.field)) {
              return (
                <th key={'th-' + index} style={th?.style ?? {}}>{th.label}</th>
              )
            }
          })}
        </tr>
        </thead>
        <tbody>
        {details?.map((item: ImportRequestDetailModel, index: number) => {
          let iSupplier = item.product;
          let iSento = iSupplier?.inventory_of_sento;
          let checked = (item.consign_product_id && selected.includes(item.consign_product_id)) || (
            isIncorrect && item.is_approved === 1 && !isConfirmed
          );
          let warehouse = iSupplier?.warehouse;
          let rowEditAble = !isConfirmed && (editable || (!editable && checked && isIncorrect));
          let rowClass = item?.is_approved === 0 && isIncorrect ? "cursor-pointer text-danger text-bold" : "cursor-pointer";

          return (
            <tr key={`order_product_${index}_${item.id}`} className={rowClass}>
              {!isConfirmed && (
                <td>
                    <div className="form-check form-check-custom">
                      <input key={`item_checkbox_${item.id}_${!!checked}`} className="form-check-input" type="checkbox"
                          value={item.id}
                          checked={!!checked}
                          name="checked"
                          disabled={!editable && !isIncorrect}
                          onChange={(e) => toggleCheck(e, item)}/>
                    </div>
                </td>
              )}
              
              {!hideCols.includes('name') && (
                <td>
                  {iSento?.name ?? ''}
                </td>
              )}
              {!hideCols.includes('supplier_name') && (
                <td>
                  {importRequest?.sento_supplier?.name ?? ''}
                </td>
              )}
              {!hideCols.includes('supplier_price') && (
                <td >
                    {formatPrice(item?.unit_price ?? 0)}
                </td>
              )}
              {!hideCols.includes('request_quantity') && (
                <td className="">
                  <div className="input-group input-group-sm mb-3 ">
                    <input className="form-control form-control-sm"  key={`receipt_quantity_${item.id}`}
                          min={0} 
                          type="number"
                          defaultValue={0}
                          value={item?.request_quantity ?? 0}
                          name="request_quantity"
                          disabled={!editable}
                          onChange={(e) => handleChangeQty(e, item)}
                          onKeyDown={e => { e.key === 'Enter' && e.preventDefault() }}

                    />
                    <span className="input-group-text text-sm-center">{ iSento?.units?.name ?? ""}</span>
                  </div>
                </td>
              )}
              {!hideCols.includes('quantity') && (
                <td className="">
                  <div className="input-group input-group-sm mb-3 ">
                    <input className="form-control form-control-sm"  key={`receipt_quantity_${item.id}`}
                          min={0} 
                          type="number"
                          defaultValue={0}
                          value={item?.quantity ?? 0}
                          name="quantity"
                          disabled={!rowEditAble}
                          onChange={(e) => handleChangeQty(e, item)}
                          onKeyDown={e => { e.key === 'Enter' && e.preventDefault() }}

                    />
                    <span className="input-group-text text-sm-center">{ iSento?.units?.name ?? ""}</span>
                  </div>
                </td>
              )}
              {!hideCols.includes('vat') && (
                <td>
                  <div className="input-group input-group-sm mb-3 ">
                    {item?.vat ?? 0}%
                  </div>
                </td>
              )}
              {!hideCols.includes('warehouse') && (
                <td>
                  {removeTrailingZeros(warehouse?.quantity ?? 0)}
                </td>
              )}
              {!hideCols.includes('note') && (
                <td>
                  <input 
                    className="form-control form-control-sm"
                    min={0} 
                    type="text"
                    value={item?.note ?? ''}
                    name="note"
                    disabled={!rowEditAble}
                    onChange={(e) => handleChangeNote(e, item)}
                    onKeyDown={e => { e.key === 'Enter' && e.preventDefault() }}
                  />
                </td>
              )}
            </tr>
          )
        })}
        </tbody>
      </table>
    </div>
  </>
}
export default ProductTable